export const setLeadingZero = (value: number): string => (value < 10 ? `0${value}` : `${value}`);

export const daysToSeconds = (days: number): number => days * 24 * 60 * 60;

export const daysToMilliseconds = (days: number): number => days * 24 * 60 * 60 * 1000;

export const hoursToSeconds = (hours: number): number => hours * 60 * 60;
